export const SESSION_OVERLAY_PANEL_CLASSES = ['overlay-panel', 'fit-height-content', 'session-overlay-panel'];
export const SESSION_OVERLAY_BACKDROP_CLASSES = ['overlay-backdrop', 'session-overlay-backdrop'];
